import React, { useState } from "react";
import { format } from "date-fns";
import clsx from "clsx";
import styles from "../../ProcedureDetail/procedure-details.module.scss";

export function ProcedureLogList({
  mdRequest,
  mdName,
  userDateFormat,
  providerName,
}) {
  const [showAll, setShowAll] = useState(false);

  const visibleRequests = showAll ? mdRequest : mdRequest.slice(0, 4);

  return (
    <h5>
      <h5 className="popup-input-field-name">Prior MD Request Log</h5>
      <div className="popup-field-box procedure-log-box">
        {visibleRequests?.map((request, idx) => (
          <div
            key={idx}
            className={clsx(styles.requestItem, {
              [styles.blurItem]: !showAll && idx === 3,
            })}
          >
            <div>
              <div className={styles.mdRequestInfo}>
                {mdName} - Requested on{" "}
                {format(request?.created_at, userDateFormat)}
              </div>
              <div className={styles.mdRequestNote}>
                {request?.md_note || ""}
              </div>
            </div>
            {!!request.is_completed_by_provider && (
              <div className={styles.providerUpdatedInfo}>
                {providerName} - Sent to MD on{" "}
                {format(request?.completed_by_provider_at, userDateFormat)}
              </div>
            )}
          </div>
        ))}
        {mdRequest.length > 3 && (
          <button
            type="button"
            onClick={() => setShowAll(!showAll)}
            className={clsx(styles.showMoreLessBtn, {
              [styles.absolute]: !showAll,
            })}
          >
            {showAll ? "Show less" : "Show more"}
          </button>
        )}
      </div>
    </h5>
  );
}
